import ControllerBase from "@/app/shared/services/controllers/controllerBase";
import IndexationStore from "../../../store/indexationStore";

export default class IndexationController extends ControllerBase {
  public indexationStore: IndexationStore;

  constructor(baseUrl: string) {
    super();
    this.indexationStore = new IndexationStore(baseUrl);
  }
}
